// extracted by mini-css-extract-plugin
export default {"switch":"MerchantContractStatus_switch__Xt-JA","isLoading":"MerchantContractStatus_isLoading__QI4m+"};